import {titleImage} from './titleImage'
import type {PreviewReturn} from '../types'

export * from './contentGroup'
export * from './link'
export * from './preview'
export * from './richText'
export * from './text'

export const defaultPreview = (props = {}): PreviewReturn => titleImage(props)
export {titleImage}
